import React, { useState } from 'react';
import "./HeroSection.scss";
import * as Constants from '../constants';
import InputForm from '../components/input/input.component';
import ComingSoonModal from '../modals/coming-soon.modal';
import GeneralInterviewModal from '../modals/general-interview.modal';
import { trackEvent } from '../utils/trackGA4.util';
import { GAConfig } from '../utils/ga-config.util';
import UtilityService from '../utils/ga4.util';
// ---Placeholder Logos (replace with your actual imports)---
import LOGO_PLACEHOLDER_1 from "../assets/images/companies/1.png";
import LOGO_PLACEHOLDER_2 from "../assets/images/companies/2.png";
import LOGO_PLACEHOLDER_3 from "../assets/images/companies/3.png";
import LOGO_PLACEHOLDER_4 from "../assets/images/companies/4.png";
import LOGO_PLACEHOLDER_5 from "../assets/images/companies/5.png";
import LOGO_PLACEHOLDER_6 from "../assets/images/companies/6.png";
import LOGO_PLACEHOLDER_7 from "../assets/images/companies/7.png";
import LOGO_PLACEHOLDER_8 from "../assets/images/companies/8.png";
import LOGO_PLACEHOLDER_9 from "../assets/images/companies/9.png";
import LOGO_PLACEHOLDER_10 from "../assets/images/companies/10.png";
import LOGO_PLACEHOLDER_11 from "../assets/images/companies/11.png";
import LOGO_PLACEHOLDER_12 from "../assets/images/companies/12.png";
import LOGO_PLACEHOLDER_13 from "../assets/images/companies/13.png";
import LOGO_PLACEHOLDER_14 from "../assets/images/companies/14.png";
import LOGO_PLACEHOLDER_15 from "../assets/images/companies/15.png";
import LOGO_PLACEHOLDER_16 from "../assets/images/companies/16.png";
import LOGO_PLACEHOLDER_17 from "../assets/images/companies/17.png";
import LOGO_PLACEHOLDER_18 from "../assets/images/companies/18.png";
import LOGO_PLACEHOLDER_19 from "../assets/images/companies/19.png";
import LOGO_PLACEHOLDER_20 from "../assets/images/companies/20.png";
import LOGO_PLACEHOLDER_21 from "../assets/images/companies/21.png";
import LOGO_PLACEHOLDER_22 from "../assets/images/companies/22.png";
import LOGO_PLACEHOLDER_23 from "../assets/images/companies/23.png";
import LOGO_PLACEHOLDER_24 from "../assets/images/companies/24.png";
import LOGO_PLACEHOLDER_25 from "../assets/images/companies/25.png";
import LOGO_PLACEHOLDER_26 from "../assets/images/companies/26.png";
import LOGO_PLACEHOLDER_27 from "../assets/images/companies/27.png";
import LOGO_PLACEHOLDER_28 from "../assets/images/companies/28.png";
import LOGO_PLACEHOLDER_29 from "../assets/images/companies/29.png";
import LOGO_PLACEHOLDER_30 from "../assets/images/companies/30.png";
import LOGO_PLACEHOLDER_31 from "../assets/images/companies/31.png";
import LOGO_PLACEHOLDER_32 from "../assets/images/companies/32.png";
import TRY_INTERVIEW_IMG from "../assets/images/try-interview-ai.jpg";


// --- End Placeholder Logos ---
interface HeroProps {
  onSubmitFile(data: any): void;
}

const HeroSection: React.FC<HeroProps> = ({ onSubmitFile }: any) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [showGeneralInterview, setShowGeneralInterview] = useState(false);
  const [modalTitle, setModalTitle] = useState('');

  const handleButtonClick = (title: string) => {
    // Track GA4 event based on button clicked
    if (title === 'General Interview by AI') {
      trackEvent(GAConfig.action.generalInterviewClick, UtilityService(), ['30 THB']);
      setShowGeneralInterview(true);
    } else if (title === 'ตามสายงาน') {
      trackEvent(GAConfig.action.jobSpecificInterviewClick, UtilityService(), ['50 THB']);
      setModalTitle(title);
      setShowComingSoon(true);
    }
  };

  const handleUseFreeInterview = () => {
    setShowComingSoon(false);
    
    // Add a small delay to ensure modal is closed and DOM is ready
    setTimeout(() => {
      const trustBadgeElement = document.getElementById('before-input');
      console.log('Element found:', trustBadgeElement); // Debug log
      
      if (trustBadgeElement) {
        // iOS Safari compatible scroll method
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        
        if (isIOS) {
          // For iOS Safari, use scrollIntoView with center alignment
          trustBadgeElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
          });
        } else {
          // For other browsers, use the original method with offset
          const rect = trustBadgeElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const elementPosition = rect.top + scrollTop;
          const offsetPosition = elementPosition - 150;
          
          console.log('Current scroll position:', scrollTop);
          console.log('Element position:', elementPosition);
          console.log('Scrolling to position:', offsetPosition);
          
          try {
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          } catch (e) {
            console.log('Smooth scroll failed, trying instant scroll');
            window.scrollTo(0, offsetPosition);
          }
        }
      } else {
        console.log('Element not found');
      }
    }, 100);
  };

  const handleGeneralInterviewSubmit = (data: any) => {
    console.log('General Interview form submitted:', data);
    // Here you can process the form data
    // For now, we'll just log it and close the modal
    setShowGeneralInterview(false);
  };

  const logos = [
    { src: LOGO_PLACEHOLDER_1, alt: 'Client Logo 1' },
    { src: LOGO_PLACEHOLDER_2, alt: 'Client Logo 2' },
    { src: LOGO_PLACEHOLDER_3, alt: 'Client Logo 3' },
    { src: LOGO_PLACEHOLDER_4, alt: 'Client Logo 4' },
    { src: LOGO_PLACEHOLDER_5, alt: 'Client Logo 5' },
    { src: LOGO_PLACEHOLDER_6, alt: 'Client Logo 6' },
    { src: LOGO_PLACEHOLDER_7, alt: 'Client Logo 7' },
    { src: LOGO_PLACEHOLDER_8, alt: 'Client Logo 8' },
    { src: LOGO_PLACEHOLDER_9, alt: 'Client Logo 9' },
    { src: LOGO_PLACEHOLDER_10, alt: 'Client Logo 10' },
    { src: LOGO_PLACEHOLDER_11, alt: 'Client Logo 11' },
    { src: LOGO_PLACEHOLDER_12, alt: 'Client Logo 12' },
    { src: LOGO_PLACEHOLDER_13, alt: 'Client Logo 13' },
    { src: LOGO_PLACEHOLDER_14, alt: 'Client Logo 14' },
    { src: LOGO_PLACEHOLDER_15, alt: 'Client Logo 15' },
    { src: LOGO_PLACEHOLDER_16, alt: 'Client Logo 16' },
    { src: LOGO_PLACEHOLDER_17, alt: 'Client Logo 17' },
    { src: LOGO_PLACEHOLDER_18, alt: 'Client Logo 18' },
    { src: LOGO_PLACEHOLDER_19, alt: 'Client Logo 19' },
    { src: LOGO_PLACEHOLDER_20, alt: 'Client Logo 20' },
    { src: LOGO_PLACEHOLDER_21, alt: 'Client Logo 21' },
    { src: LOGO_PLACEHOLDER_22, alt: 'Client Logo 22' },
    { src: LOGO_PLACEHOLDER_23, alt: 'Client Logo 23' },
    { src: LOGO_PLACEHOLDER_24, alt: 'Client Logo 24' },
    { src: LOGO_PLACEHOLDER_25, alt: 'Client Logo 25' },
    { src: LOGO_PLACEHOLDER_26, alt: 'Client Logo 26' },
    { src: LOGO_PLACEHOLDER_27, alt: 'Client Logo 27' },
    { src: LOGO_PLACEHOLDER_28, alt: 'Client Logo 28' },
    { src: LOGO_PLACEHOLDER_29, alt: 'Client Logo 29' },
    { src: LOGO_PLACEHOLDER_30, alt: 'Client Logo 30' },
    { src: LOGO_PLACEHOLDER_31, alt: 'Client Logo 31' },
    { src: LOGO_PLACEHOLDER_32, alt: 'Client Logo 32' },
    // Add more logos as needed
  ];
  return (
    <section
      id="hero-section"
        className="snap-section !pt-[10vh] md:!pt-[15vh] bg-gradient-to-br from-slate-100 via-purple-100 to-pink-100"
    >
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between gap-8 md:gap-12 h-full ">
        {/* Left Column: Key Message */}
        <div className="md:w-1/2 text-center md:text-left py-8 md:py-0">
          <h1 className="text-3xl md:text-2xl lg:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 HeroTitle">
            <div dangerouslySetInnerHTML={{ __html: Constants.HERO_HEADLINE }}></div>
          </h1>
          <div className='w-full h-[340px] bg-transparent rounded-[12px] mt-2 mb-2 flex items-center justify-center'>
              <img src={TRY_INTERVIEW_IMG} className='max-w-full max-h-full object-contain rounded-[12px]' />
          </div>
          
          {/* New Headline and Buttons Section */}
          <div className='w-full mt-6 mb-6'>
            <span className='text-md md:text-xl lg:text-2xl text-center text-slate-700 mb-6 block'>
            {Constants.HERO_HEADLINE_SMALL}
            </span>
            
            {/* Button Grid */}
            <div className='grid grid-cols-2 gap-4 max-w-md mx-auto'>
              <button 
                onClick={() => handleButtonClick('General Interview by AI')}
                className='bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-3 px-2 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex flex-col items-center'
              >
                <span>General Interview</span>
                <span className='text-sm font-normal opacity-90'>30 THB</span>
              </button>
              <button 
                onClick={() => handleButtonClick('ตามสายงาน')}
                className='bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white font-semibold py-3 px-2 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex flex-col items-center'
              >
                <span>ตามสายงาน</span>
                <span className='text-sm font-normal opacity-90'>50 THB</span>
              </button>
            </div>
          </div>
          <p className="text-lg md:text-sm text-slate-600 mb-10 max-w-2xl mx-auto md:mx-0">
            {Constants.HERO_SUBHEADLINE}
          </p>
          {/* --- Logo Scroller Start --- */}
          <div className="mt-8 mb-8 overflow-hidden w-full max-w-2xl mx-auto md:mx-0">
            <p className="text-sm text-slate-500 mb-4 text-center md:text-left">Trusted by leading companies:</p>
            <div className="logo-scroller">
              <div className="logo-scroller-inner">
                {/* Render logos twice for seamless loop */}
                {[...logos, ...logos].map((logo, index) => (
                  <div key={index} className="logo-item flex-shrink-0">
                    <img src={logo.src} alt={logo.alt} className="h-10 md:h-12 object-contain" />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* --- Logo Scroller End --- */}
          <p id="trust-badge-section" className="text-sm text-purple-500">{Constants.HERO_TRUST_BADGE}</p>
        </div>
        <div id="before-input" className='mt-[-5vh] md:mt-[-10vh]'></div>

        {/* Right Column: Form */}
        <div id="input-form-section" className="md:w-1/2 w-full max-w-lg">
          {/* <HeroForm /> */}
          <InputForm submitFile={onSubmitFile}></InputForm>
        </div>
      </div>
      
      {/* Coming Soon Modal */}
      <ComingSoonModal 
        isOpen={showComingSoon} 
        onClose={() => setShowComingSoon(false)} 
        title={modalTitle}
        onUseFreeInterview={handleUseFreeInterview}
      />
      
      {/* General Interview Modal */}
      <GeneralInterviewModal 
        isOpen={showGeneralInterview} 
        onClose={() => setShowGeneralInterview(false)} 
        onSubmit={handleGeneralInterviewSubmit}
      />
    </section>
  );
};

export default HeroSection;
